import React from 'react';
import Loading from './Components/Loading';
import { useLoading } from './LoadingContext';

const GlobalLoader: React.FC = () => {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 dark:bg-black/60">
      <div className="p-3">
        <Loading />
      </div>
    </div>
  );
};

export default GlobalLoader;
